/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Index_Description_TopInputs */

const en_index_description_top = /** @type {(inputs: Index_Description_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We forward deploy engineers to automate operations across your business with AI agents.`)
};

/**
* | output |
* | --- |
* | "We forward deploy engineers to automate operations across your business with AI agents." |
*
* @param {Index_Description_TopInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const index_description_top = /** @type {((inputs?: Index_Description_TopInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Index_Description_TopInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_index_description_top(inputs)
});